// Port of api/fuel/app/classes/insights/worth/trending.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

function monthStartOffset(monthOffset) {
	var date = new Date()
	date.setUTCDate(1)
	date.setUTCHours(0, 0, 0, 0)
	date.setUTCMonth(date.getUTCMonth() + monthOffset)
	return Math.floor(date.getTime() / 1000)
}

export default Segment.extend({
	name: 'trending',
	types: [Constants.TYPE_USER],
	insight: ['trending.period', 'trending.direction'],
	detail: ['trending'],
	run: function(type, owner, userIndex, detail, filter) {
		var limit = detail ? 1000 : 5
		var direction = (filter && filter['trending.direction']) ? filter['trending.direction'] : 'up'
		var period = (filter && filter['trending.period'] !== undefined) ? filter['trending.period'] : 3
		var trending = []

		var currentRows = Util.queryFast(
			'SELECT c.collection_id AS c, g.game_id AS g, c.game_version_id AS v,' +
			' COALESCE(NULLIF(v.game_version_worth_value, 0), g.game_worth_value, 0) AS w,' +
			' c.collection_rating AS r, c.collection_plays AS p' +
			' FROM (collection c JOIN game g ON c.game_id = g.game_id)' +
			' LEFT JOIN game_version v ON v.game_version_id = c.game_version_id' +
			' WHERE c.user_id = ' + owner.get_id() +
			' AND c.collection_own = 1 AND g.game_worth_value > 0'
		)
		var current = {}
		for (var i = 0; i < currentRows.length; i++) current[parseInt(currentRows[i].c, 10)] = currentRows[i]

		var previousRows = []
		if (period === 'owned') {
			previousRows = Util.queryFast(
				'SELECT c.collection_id AS c, COALESCE(NULLIF(v.insight_value, 0), g.insight_value, 0) AS w' +
				' FROM (collection c JOIN insight_game_value g ON c.game_id = g.game_id' +
				' AND g.insight_value_count > 0 AND g.insight_date > c.collection_date_owned)' +
				' LEFT JOIN insight_game_version_value v ON v.game_version_id = c.game_version_id' +
				' AND v.insight_value_count > 0 AND v.insight_date > c.collection_date_owned' +
				' WHERE c.user_id = ' + owner.get_id() + ' AND c.collection_own = 1'
			)
		} else {
			previousRows = Util.queryFast(
				'SELECT c.collection_id AS c, COALESCE(NULLIF(v.insight_value, 0), g.insight_value, 0) AS w' +
				' FROM (collection c JOIN insight_game_value g ON c.game_id = g.game_id' +
				' AND g.insight_date = ' + monthStartOffset(0 - parseInt(period, 10)) +
				' AND g.insight_value_count > 0)' +
				' LEFT JOIN insight_game_version_value v ON v.game_version_id = c.game_version_id' +
				' AND v.insight_date = ' + monthStartOffset(0 - parseInt(period, 10)) +
				' AND v.insight_value_count > 0' +
				' WHERE c.user_id = ' + owner.get_id() + ' AND c.collection_own = 1'
			)
		}

		var previous = {}
		for (var j = 0; j < previousRows.length; j++) previous[parseInt(previousRows[j].c, 10)] = previousRows[j]

		var differences = []
		var ids = Object.keys(current)
		for (var k = 0; k < ids.length; k++) {
			var id = parseInt(ids[k], 10)
			if (!previous[id]) continue
			var entry = {
				c: id,
				g: parseInt(current[id].g, 10),
				v: parseInt(current[id].v, 10) || 0,
				w: parseFloat(current[id].w) || 0,
				r: parseFloat(current[id].r) || 0,
				p: parseInt(current[id].p, 10) || 0,
				d: (parseFloat(current[id].w) || 0) - (parseFloat(previous[id].w) || 0)
			}
			if ((direction === 'up' && entry.d > 0) || (direction === 'down' && entry.d < 0)) differences.push(entry)
		}

		differences = Util.sort_by_field(differences, 'd', direction === 'down').slice(0, limit)

		for (var d = 0; d < differences.length; d++) {
			var item = differences[d]
			this._references.games.push(item.g)

			if (detail) {
				trending.push({
					id: item.g,
					worth: Math.round(item.w),
					difference: Math.round(item.d * 100) / 100
				})
			} else {
				trending.push({
					g: item.g,
					w: Math.round(item.w * 100) / 100,
					r: item.r,
					p: item.p,
					d: Math.round(item.d * 100) / 100
				})
			}
		}

		return {
			trending: trending
		}
	}
})
